var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import IconBase from "@irati/ui/src/Icon";
import { breakWord } from "../global/helpers";
export var Icon = styled(IconBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 5px;\n"], ["\n  margin-right: 5px;\n"])));
export var TextHelper = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  ", "\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  ", "\n  ", "\n"])), breakWord, function (_a) {
    var small = _a.small;
    return small && "font-size: 12px;";
});
var templateObject_1, templateObject_2;
